import { render, staticRenderFns } from "./orderManage.vue?vue&type=template&id=09a20383&scoped=true&"
import script from "./orderManage.vue?vue&type=script&lang=js&"
export * from "./orderManage.vue?vue&type=script&lang=js&"
import style0 from "./orderManage.vue?vue&type=style&index=0&id=09a20383&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a20383",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09a20383')) {
      api.createRecord('09a20383', component.options)
    } else {
      api.reload('09a20383', component.options)
    }
    module.hot.accept("./orderManage.vue?vue&type=template&id=09a20383&scoped=true&", function () {
      api.rerender('09a20383', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/onlineshop/orderManage.vue"
export default component.exports